<template>
  <div>
    <select class="form-control" @input="changed">
        <option value="">All</option>
        <option value="0">No</option>
        <option value="1">Yes</option>
    </select>
  </div>
</template>
<script>
export default {
    props: ['column'],
    methods: {
        changed(selected) {
            let query = {};
            query['m_'+this.column.key] = selected.target.value;
            this.$emit('input', query);
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/metronic/table/header/ColumnBoolean.vue